import { isBookingFormInputField } from "../types/bookingForm";
export function getBookingFormFieldValue(values, field) {
    const stored = values[field.id];
    if (field.type === "checkbox") {
        return stored === true;
    }
    return typeof stored === "string" ? stored : "";
}
export function isFieldVisible(field, values) {
    if (!field.showWhen)
        return true;
    const dependentValue = values[field.showWhen.fieldId];
    return String(dependentValue ?? "") === field.showWhen.equals;
}
export function getVisibleBookingFormFields(schema, values) {
    if (!schema?.fields.length)
        return [];
    return schema.fields.filter((field) => isBookingFormInputField(field) && isFieldVisible(field, values));
}
export function validateBookingForm(schema, values) {
    const visibleFields = getVisibleBookingFormFields(schema, values);
    if (!visibleFields.length)
        return null;
    for (const field of visibleFields) {
        if (!field.required)
            continue;
        const value = getBookingFormFieldValue(values, field);
        if (field.type === "checkbox") {
            if (value !== true) {
                return `Please confirm: ${field.label}`;
            }
            continue;
        }
        if (!String(value).trim()) {
            return `Please enter ${field.label.toLowerCase()}`;
        }
    }
    return null;
}
export function formatBookingFormDisplayValue(field, value) {
    if (field.type === "checkbox") {
        return value === true ? "Yes" : "No";
    }
    const text = String(value ?? "").trim();
    if (!text)
        return "—";
    const option = field.options?.find((o) => o.value === text);
    return option?.label ?? text;
}
export function getFilledBookingFormEntries(schema, values) {
    if (!schema)
        return [];
    return getVisibleBookingFormFields(schema, values)
        .map((field) => {
        const raw = values[field.id];
        if (field.type === "checkbox") {
            if (raw !== true)
                return null;
        }
        else if (!String(raw ?? "").trim()) {
            return null;
        }
        return {
            label: field.label,
            value: formatBookingFormDisplayValue(field, raw),
        };
    })
        .filter((entry) => entry != null);
}
